import { FormControl } from '@angular/forms';
import { ChangeDetectionStrategy, Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { untilDestroy } from '@ngrx-utils/store';
import { filter, distinctUntilChanged } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchComponent implements OnInit, OnDestroy {

  input = new FormControl();
  showDrawer$ = new BehaviorSubject(false);

  @HostListener('window:popstate', ['$event'])
  onBack() {
    this.close();
  }

  constructor() { }

  ngOnInit(): void {
    this.showDrawer$.pipe(
      filter(showDrawer => !showDrawer),
      untilDestroy(this)
    ).subscribe(() => this.input.reset());

    this.showDrawer$.pipe(
      distinctUntilChanged(),
      untilDestroy(this)
    ).subscribe(opened => {
      if (opened) {
        history.pushState('openedScreen', 'openedScreen');
      } else if (history.state === 'openedScreen') {
        history.back();
      }
    });
  }

  ngOnDestroy(): void {}

  open() {
    this.showDrawer$.next(true);
  }

  close() {
    this.showDrawer$.next(false);
  }

  toggle() {
    this.showDrawer$.next(!this.showDrawer$.getValue());
  }

}
